import API from '@/api/home.js';
import { undistributedTipModal } from '../../layout/components/modal/index'


const undistributeMixin = {
    created() {
        this.getUndistributedSubItem();
    },
    methods:{
        getUndistributedSubItem(){
            let routeMeta = this.$route.meta;
            /* tab页 需要用pid来请求页面权限，智能托管是个列外 */
            let navId = '';
            if(this.$route.name=='intelligent_managed_rule'){
                navId = routeMeta.id;
            }else{
                navId = routeMeta.isTabItem?routeMeta.pid:routeMeta.id;
            }

            API.getUndistributedSubItem({
                page_action_id:navId,
            }).then(res=>{
                console.log('getUndistributedSubItem',res);
                let resData = res.data||{};
                let limit_second = resData.limit_second||0;
                let subItemData = resData.undistributed_subitem||{};
                let selfData = subItemData.self||{};
                let memberData = subItemData.member||{};
                let memberModal = null;

                if((selfData.data||[]).length>0){
                    undistributedTipModal({
                        props: {
                            limit:limit_second,
                            desc:selfData.title,
                            list:selfData.data,
                            hideClose:true,
                            cancelButtonText:'下次维护',
                            confirmButtonText:'立即维护',
                        },
                        cbs: {
                            onClose: (data)=> {
                                console.log('onClose',data);
                                if((memberData.data||[]).length>0){
                                    this.showMemberTipModal(memberData);
                                }
                            },
                            onConfirm:(data)=>{
                                console.log('onConfirm',data,selfData.data);
                                let productIdStr = (selfData.data||[]).map(item=>item.id).join(',');
                                if(!productIdStr) return;
                                let jumpUrl = this.getV3ProductJumpUrl(productIdStr);
                                if(!jumpUrl){
                                    this.$message.warning('未维护产品数量过多，请前往标签管理-产品页面按媒体筛选维护');
                                    return;
                                }
                                window.open(jumpUrl, '_blank');
                            },
                        }
                    })

                }else if((memberData.data||[]).length>0){
                    this.showMemberTipModal(memberData);
                }
            },err=>{
                console.log('getUndistributedSubItem err',err);
            })
        },
        /* 跳转 v3 产品页：生产走生产链接，其余（测试/开发）走测试链接；URL 超长返回空 */
        getV3ProductJumpUrl(productIdStr){
            let v3ProductUrl = process.env.VUE_APP_V3_PRODUCT_URL;
            if(!v3ProductUrl){
                let isRealProd = process.env.NODE_ENV === 'production' && process.env.VUE_APP_IS_TEST !== 'true';
                v3ProductUrl = isRealProd
                    ? 'https://wk-adam.wankacn.com/info_manage/tag/product'
                    : 'https://adam.gm825.net/info_manage/tag/product';
            }
            let jumpUrl = `${v3ProductUrl}?product_id=${productIdStr}`;
            /* URL 超浏览器安全阈值（2000 字符）不跳转 */
            if(jumpUrl.length > 2000){
                return '';
            }
            return jumpUrl;
        },
        showMemberTipModal(memberData){
            if((memberData.data||[]).length>0){
                undistributedTipModal({
                    props: {
                        limit:0,
                        desc:memberData.title,
                        list:memberData.data,
                        hideClose:true,
                        cancelButtonText:'已知晓',
                        confirmButtonText:'立即查看',
                        tag:'member',
                    },
                    cbs: {
                        onClose: (data)=> {
                            console.log('onClose',data);
                        },
                        onConfirm:(data)=>{
                            console.log('onConfirm',data);
                            let allList = [];
                            (memberData.data||[]).forEach(item=>{
                                let children = item.child||[];
                                children.forEach(inner=>{
                                    if(!allList.find(k=>k.id==inner.id)){
                                        allList.push({...inner});
                                    }
                                })
                            });

                            this.$router.push({
                                name:'app_management_page',
                                params:{
                                    list:allList,
                                },
                            });
                        },
                    }
                })
            }
        }
    }
};

export {
    undistributeMixin,
}
